import { CommonModule, NgFor } from '@angular/common';
import { Component, Inject, OnChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioButton, MatRadioGroup, MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'app-dialog-graphscale-settings',
  templateUrl: './dialog-graphscale-settings.component.html',
  styleUrls: ['./dialog-graphscale-settings.component.css'],
  standalone: true,
  imports: [CommonModule,NgFor,FormsModule,MatButtonModule,MatRadioModule]
})
export class DialogGraphscaleSettingsComponent implements OnChanges {
  loading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<DialogGraphscaleSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(this.data) 
    if (this.data.loading !== undefined) {
      this.loading = this.data.loading;
    } else {
      this.loading = false;
    }
  }

  ngOnChanges() {
    console.log(this.data)
    if (this.data.loading !== undefined) {
      this.loading = this.data.loading;
    } else {
      this.loading = false;
    }
  }

  updateData(newData: any): void {
    this.loading = false;
    this.data = newData;
  }

  onSave(): void {
    this.dialogRef.close(this.data); // Pass modified data back to parent component
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
